import { curry, length, is, omit, keys, difference } from 'ramda';

import htmlSanitizer from './html';
import reactSanitizer from './react';
import sanitizers from './tag';

const WHITE_LIST = ['disabled'];

const extraProps = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string, any>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sanitizedProps: Record<string, any>
): string[] => difference(keys(omit(WHITE_LIST, props)), keys(sanitizedProps));

/**
 * Remove all extra props that is not w3c compliant.
 *
 * @param {String|Function|Array} tag The react element type
 * @param {Array} filters The extra propNames to remove from props
 * @param {Object} props The props to cleans
 */
const sanitizeProps = curry((tag, filters, props) => {
  const filteredProps = omit(filters || [], props);

  // We clean props only when we render a dom component
  if (!is(String, tag)) {
    return filteredProps;
  }

  const tagSanitizer = sanitizers[tag];
  const sanitizedProps = {
    ...htmlSanitizer(filteredProps),
    ...reactSanitizer(filteredProps),
    ...(tagSanitizer && tagSanitizer(filteredProps)),
  };

  const diff = extraProps(filteredProps, sanitizedProps);
  if (length(diff)) {
    // eslint-disable-next-line no-console
    console.warn(`This props are not w3c valid for "${tag}" tag : `, diff);
  }

  // Returns sanitizedProps to force filters
  // return sanitizedProps;
  return filteredProps;
});

export default sanitizeProps;
